import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import TypeformView from '../../TypeformView'
import $ from 'jquery';
import uuid from 'uuid';
import DataLoader from '../../../../app/DataLoader'
import { signout } from '../../../../redux/actions/userActions';

class CMMCAssessmentContent extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            categoryIndex: 0,
            isActive: true,
            hoverColor: true,
            bgColr: "white-bg",
            loading: true,
            loaded: false,
            updateForm: true,
            forms: [],
            showTourButton: false
        }
    }

    scrollContent (direction) {
        const step = 370;

        $("#card-content").animate({
            scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
        });
    }

    setUpdate = (title, active) => {
        this.setState({ updateForm: (title !== active) })
    }

    selectNewCatagory (category) {
        this.setState({ categoryIndex: category });
    }

    componentDidMount () {
        const tenantId = localStorage.getItem('tenant')
        let forms
        if(["prod"].includes(process.env.REACT_APP_ENV)){
            forms = [
                {
                    name: 'CMMC Assessment',
                    url: `https://postured.typeform.com/to/DAteSeva?tenantid=${tenantId}&frameworkname=cmmc&frameworkid=3`,
                    description: '',
                }
            ]
        }
        else{
            forms = [
                {
                    name: 'CMMC Assessment',
                    url: `https://postured.typeform.com/to/Ub5nVw2L?tenantid=${tenantId}&frameworkname=cmmc&frameworkid=3`,
                    description: '',
                }
            ]            
        }

        this.setState({ forms: forms })
    }

    render () {
        const {setShowTourButton} = this.props;
        return (
            <DataLoader>
                <div className="comp-assessment">
                    <div>
                        <Row>
                            <Col md={12} id="test">
                                <h3 className='page-title'>CMMC Compliance</h3>
                                <h3 className='page-subhead subhead'>
                                    Determine the state of your company's compliance health
                                </h3>
                            </Col>
                        </Row>
                    </div>

                    {
                        this.state.forms.map((category, idx) => {
                            return <div key={uuid()}><TypeformView
                                setShowTourButton={setShowTourButton}
                                categoryIndex={this.state.categoryIndex}
                                i={idx}
                                url={`${category.url}&email=${this.props.user.email}`+
                                `&tenantname=${this.props.tenant ? this.props.tenant.companyName: ""}`} />
                                </div>
                        }
                        )
                    }
                </div >
            </DataLoader>
        )
    }
}

function mapStateToProps (state) {
    return {
        user: state.auth.user,
        tenant: state.auth.tenant,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        dataLoaded: !state.controlsData.loading,
        sidebar: state.sidebar
    }
}

export default connect(mapStateToProps, { signout })(withRouter(CMMCAssessmentContent))


// WEBPACK FOOTER //
// ./src/components/assessment/components/CMMC/CMMCAssessmentContent.js